module.exports = __webpack_public_path__ + "img/user.ee262c61.png";